import React, { useEffect, useState } from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css/free-mode"
import "swiper/css/navigation"
import "swiper/css/thumbs"
import { Navigation, Autoplay } from "swiper"
import Image from "next/legacy/image"
import { useRef } from "react"
import { renderTime } from "utils/time"
import { useRouter } from "next/router"
import useStore from "components/ui/Context"
import { getAccessToken } from "lib/Cookies"
import TagPremium from "components/TagPremium"

export default function Slide({ slides }) {
  const router = useRouter()
  const { togleModalLogin, setModalLive } = useStore()
  const isMonter = useRef(false)
  const [swiperBanner, setSwiperBanner] = useState()
  const __time = useRef()
  const [isMobile, setIsMobile] = useState("mobile")
  const [indexSlide, setIndexSlide] = useState(0)

  function onMouseOver(index) {
    if (__time.current) clearTimeout(__time.current)
    __time.current = setTimeout(() => {
      swiperBanner?.slideTo(index)
    }, 400)
  }

  function onNextPath(item) {
    let isPlay
    if (item?.type_link === 1 && (!item.event || item.event?.status === "finish")) {
      isPlay = false
    } else {
      isPlay = true
    }
    clearInterval(__time.current)
    __time.current = null
    if (isPlay) {
      if (item?.type_link === 1 && item?.event) {
        if (item?.event?.status === "live") {
          router.push(convertLink(item))
          return true
        }
        setModalLive({
          show: true,
          isVod: true,
          info: {
            title: item?.event?.name,
            start_time: item?.event?.start_time
          }
        })
        return false
      }
      if (item?.type_link !== 0 && !getAccessToken()) {
        if (item?.event?.is_protected || item?.video?.is_protected) {
          isMonter.current = true
          togleModalLogin()
          return false
        }
      }
      if (!item?.event && !item?.video) {
        // router.push(convertLink(slides[step]))
        window.open(convertLink(item))
        return false
      }
    }
    router.push(convertLink(item))
  }

  function handlePadding() {
    if (slides?.length < 6) {
      return { paddingLeft: "40px", paddingRight: "40px" }
    } else {
      return { paddingLeft: "0px", paddingright: "0px" }
    }
  }

  useEffect(() => {
    return () => {
      if (__time.current) clearTimeout(__time.current)
    }
  }, [])

  useEffect(() => {
    if (window.innerWidth < 768) {
      setIsMobile("mobile")
    } else if (window.innerWidth >= 768 && window.innerWidth < 1280) {
      setIsMobile("ipad")
    } else {
      setIsMobile("desktop")
    }
  }, [])

  useEffect(() => {
    handlePadding()
  }, [])

  return (
    <div className="slide max-w-screen-xl m-auto relative lg:p-0 p-4 lg:mt-4 mt-0">
      <Swiper
        key={"slide3"}
        spaceBetween={16}
        modules={[Navigation, Autoplay]}
        className="swiper__live"
        loop={true}
        navigation={true}
        breakpoints={{
          0: {
            slidesPerView: 1,
            slidesPerGroup: 1
          }
        }}
        autoplay={{
          delay: 7000,
          disableOnInteraction: false
        }}
        onSlideChange={(e) => {
          setIndexSlide(e.realIndex)
        }}
      >
        {slides?.map((params) => {
          const { thumbnail, base_url, name, event, type_link, is_monopoly } = params

          return (
            <SwiperSlide key={params?.id}>
              <div className="fix_img cursor-pointer rounded-xl relative md:mx-8 lg:mx-20 xl:mx-0">
                <Image
                  className="rounded-xl md:rounded-none"
                  blurDataURL={
                    renderUrl(base_url, thumbnail, "160x90") ||
                    "https://stvinaprod.vtvcab.vn/797864df-e895-426e-8573-210ca0d4b26c.png"
                  }
                  placeholder="blur"
                  src={
                    renderUrl(base_url, thumbnail, "720x405") ||
                    "https://stvinaprod.vtvcab.vn/797864df-e895-426e-8573-210ca0d4b26c.png"
                  }
                  height={718}
                  width={1280}
                  alt={name}
                  onClick={() => {
                    onNextPath(params)
                  }}
                />
                {type_link === 1 && (
                  <div className="block md:hidden">
                    <TagPremium package_type={event?.package_type} border={true} />
                    {event?.status === "live" && (
                      <div className="absolute shadow bottom-2 right-2 bg-dark-50 rounded-xl  items-center px-1 3xl:right-4 2xl:right-4 flex">
                        <div className=" rounded-full h-2 w-2 bg-red-500 mr-1"></div>
                        <div className="text-dark-800 font-semibold" style={{ fontSize: 10 }}>
                          LIVE
                        </div>
                      </div>
                    )}
                    {event?.status === "not_started" && (
                      <div className="absolute z-20 shadow bottom-2 right-2 bg-dark-50 rounded-full flex items-center px-2">
                        <div className="text-dark-800 font-semibold text-xs">Sắp diễn ra</div>
                      </div>
                    )}
                    {event?.status === "fisnish" && (
                      <div className="absolute z-20 shadow  bottom-2 right-2 bg-dark-50 rounded-full flex items-center px-2">
                        <div className="text-dark-800 font-semibold text-xs">FISNISH</div>
                      </div>
                    )}
                    {is_monopoly && (
                      <div className="absolute top-[3px] right-2 w-[48px] h-[37px]">
                        <Image
                          src={"https://stvinaprod.vtvcab.vn/1602635b-7a7e-4dc0-aab3-f596b5635898.png"}
                          width={480}
                          height={350}
                          alt={name}
                          onError={() => "https://stvinaprod.vtvcab.vn/4ab5f0e3-d616-4834-9485-d54b0ebb7115.png"}
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div className="block md:hidden p-4">
                <div className="text-dark-100 line-clamp-1   bottom-0 text-sm md:text-xl md:font-medium font-bold">
                  {name}
                </div>
                <time dateTime={new Date(event?.start_time)} className="text-dark-500 md:text-sm text-xs">
                  {/* {event?.is_live ? renderTime(event?.start_time) : renderTimeFromNow(event?.created)} */}
                  {renderTime(event?.start_time)}
                </time>
              </div>
            </SwiperSlide>
          )
        })}
      </Swiper>
      <div className="absolute linear__slide h-32 w-full z-10 bottom-0"></div>
      <div className="absolute bottom-[48px] w-full z-20">
        <div className="flex justify-center items-center">
          <div className=" pagination__slides" style={{ width: `calc(${slides?.length} * 24px + 48px)` }}>
            {slides?.map((slide, index) => {
              if (index === indexSlide) {
                return <div className="rounded-[32px] pagination__item_active" key={index}></div>
              } else {
                return <div className="rounded-[32px] pagination__item" key={index}></div>
              }
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
function renderUrl(base_url, thumbnail, size) {
  if (thumbnail?.includes("http")) return thumbnail
  return `${base_url}${size}/${thumbnail}`
}

function renderUrlSlideSmall(url) {
  return url?.replace("1280x720", "720x405")
}

function convertLink(item) {
  const { type_link, link, event, video } = item
  if (type_link === 1) {
    return `/video?id=${event?.id}&type=1`
  }
  if (type_link === 2) {
    return `/video?id=${event?.id}&type=2`
  }
  return link
}

const iconNext = (
  <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.2451 25.491L20.2147 18.5214L13.2451 11.5366L15.3908 9.39099L24.5212 18.5214L15.3908 27.6518L13.2451 25.491Z"
      fill="white"
      fillOpacity="0.87"
    />
  </svg>
)
const IconPre = (
  <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23.7543 25.491L16.7847 18.5214L23.7543 11.5366L21.6087 9.39099L12.4782 18.5214L21.6087 27.6518L23.7543 25.491Z"
      fill="white"
      fillOpacity="0.87"
    />
  </svg>
)
const iconPremium = (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.45681 3.36076L4.10856 0.709007C4.24931 0.568257 4.44006 0.489258 4.63881 0.489258C4.83781 0.489258 5.02856 0.568257 5.16931 0.709007C5.71256 1.25251 6.74706 2.28701 7.29056 2.83026C7.43131 2.97101 7.51031 3.16176 7.51031 3.36076C7.51031 3.55951 7.43106 3.75026 7.29056 3.89101L4.63881 6.54276L4.10856 6.01226C4.01106 5.91476 3.85256 5.91476 3.75506 6.01226C3.65731 6.11001 3.65731 6.26826 3.75506 6.36576L4.28531 6.89626L3.90956 7.27201C3.76881 7.41276 3.57806 7.49176 3.37906 7.49176C3.18031 7.49176 2.98956 7.41276 2.84881 7.27201C2.57906 7.00226 2.25331 6.67651 2.25331 6.67651C2.15556 6.57901 2.15556 6.42051 2.25331 6.32301C2.25331 6.32301 2.32106 6.25526 2.41106 6.16526C2.48281 6.09351 2.52306 5.99626 2.52306 5.89476C2.52306 5.79326 2.48281 5.69601 2.41106 5.62426C2.41106 5.62401 2.41081 5.62401 2.41081 5.62376C2.33906 5.55201 2.24156 5.51176 2.14031 5.51176C2.03881 5.51176 1.94156 5.55201 1.86981 5.62376C1.77956 5.71401 1.71181 5.78151 1.71181 5.78151C1.61431 5.87926 1.45606 5.87926 1.35831 5.78151C1.35831 5.78151 1.00981 5.43301 0.727562 5.15076C0.586812 5.01001 0.507812 4.81926 0.507812 4.62051C0.507812 4.42151 0.586812 4.23076 0.727562 4.09001L1.10331 3.71426L1.63356 4.24451C1.73131 4.34201 1.88956 4.34201 1.98731 4.24451C2.08481 4.14701 2.08481 3.98851 1.98731 3.89101L1.45681 3.36076ZM4.40681 2.78001L4.89306 2.43026C4.96881 2.37551 5.06906 2.36776 5.15256 2.41026C5.23581 2.45276 5.28856 2.53826 5.28906 2.63201L5.29181 3.23076L5.77456 3.58501C5.85006 3.64051 5.88831 3.73326 5.87356 3.82576C5.85906 3.91826 5.79406 3.99476 5.70506 4.02401L5.13631 4.21176L4.94856 4.78051C4.91931 4.86926 4.84281 4.93426 4.75031 4.94901C4.65781 4.96351 4.56506 4.92551 4.50981 4.85001L4.15531 4.36701L3.55656 4.36426C3.46306 4.36376 3.37756 4.31126 3.33506 4.22776C3.29256 4.14451 3.30006 4.04426 3.35481 3.96826L3.70456 3.48226L3.52206 2.91176C3.49356 2.82251 3.51731 2.72501 3.58356 2.65876C3.64956 2.59276 3.74731 2.56901 3.83631 2.59751L4.40681 2.78001Z"
      fill="#000E2B"
    />
  </svg>
)
